import React from 'react'
import CatalogCategory from './catalog/CatalogCategory'

interface Props {
    list: {
        id?: string;
        title: string;
        image_url: string;
        bottomLine: string;
        description?: string
    }[],
    classItem?: string
}

const FeaturesBlock: React.FC<Props> = ({ list, classItem }) => {
    return (
        <ul style={{ marginBottom: 120 }} className='useful-materials__block container'>
            {list?.map((item) => (
                <CatalogCategory
                    key={item.id}
                    classItem={classItem}
                    item={item}
                    type={'labs'} />
            ))}
        </ul>
    )
}

export default FeaturesBlock
